import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Loading from '@/shared/components/Loading';
import { paths } from '@/shared/helpers/paths';
import { ArticlesPage } from './components/ArticlesPage';

export const cadsAiArticlesBaseUrl = paths.CADS_AI.HOME.ARTICLE;

const Articles = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path={cadsAiArticlesBaseUrl} component={ArticlesPage} />
      </Switch>
    </Suspense>
  );
};

export default Articles;
